import { ApiClient } from 'services/ApiClient';
import { ITransactionFee, ITransactionFeeParams } from 'interfaces';

// == TRANSACTION FEE

export async function getTransactionFee(
  params: Partial<ITransactionFeeParams>
) {
  const { method, token_standard, token_id, blockchain } = params;
  if (!token_standard || !method) {
    return Promise.resolve({
      data: { data: { price: 0, formatted_price: '0' } }
    });
  }
  return await ApiClient.get<{ data: ITransactionFee }>(
    `/transaction-fee/${method}/${token_standard}`,
    {
      params: {
        token_id,
        blockchain
      }
    }
  );
}
